import { __ } from "i18n-for-browser";

export default async function getKokeilulupa(data, { isReadOnly }) {
  return {
    structure: [
      {
        anchor: "iskokeilulupa",
        components: [
          {
            anchor: "A",
            name: "CheckboxWithLabel",
            styleClasses: [""],
            properties: {
              isReadOnly,
              isRequired: false,
              title: __("common.kokeilulupa"),
              type: "text",
              value: false
            }
          }
        ]
      }
    ]
  };
}
